import { render, staticRenderFns } from "./DeleteRequestModal.vue?vue&type=template&id=3c89af10&"
import script from "./DeleteRequestModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRequestModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports